import React, {useEffect} from 'react';
import 'semantic-ui-css/semantic.min.css'

import "./Styles/styles.scss";
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import PrivateRoute from './Components/PrivateRoute';
import LoginPage from "./Pages/LoginPage";
import AuthProvider from "./Context/RootContext";
import WelcomePage from "./Pages/WelcomePage";
import AboutPage from "./Pages/AboutPage";
import MainContentPage from "./Pages/MainContentPage";
import {Scrollbars} from 'rc-scrollbars';
import PublicPluginsPage from "./Pages/PublicPluginsPage";
import 'rc-slider/assets/index.css';
import PublicRoute from "./Components/PublicRoute";
import CookieConsent from "react-cookie-consent";
import {ToastProvider} from "react-toast-notifications";
import AccountPage from "./Views/AccountPage";
import LanguageProvider from "./Context/LanguageContext";
import InvalidLocalTimePage from "./Pages/InvalidLocalTimePage";
import keys from "./translations/keys";
import {IRouteItem} from "./routes";
import {useTranslation} from "react-i18next";
import ResetPasswordPage from "./Pages/ResetPasswordPage";
import ResetPasswordErrorPage from "./Pages/ResetPasswordErrorPage";
import ResetPasswordErrorConfirm from "./Pages/ResetPasswordErrorConfirm";
import ForgotPasswordPage from "./Pages/ForgotPasswordPage";
import Contacts from "./Pages/Contacts";
import SuccessPayment from "./Views/SuccessPayment";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import BuySubscribePage from "./Pages/BuySubscribePage";
import SignInCallback from "./Pages/SignInCallback";
import DataProvider from "./Context/DataContext";
import SilentRenew from "./Pages/SilentRenew";
import LangSelector from "./Components/LangSelector";

function App() {
    const {t} = useTranslation();

    const RouteItems: IRouteItem[] = [
        {
            name: t(keys.lefPanel.dashboard.main),
            url: '/main',
            icon: () => {
                return (
                    <svg width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M7 2H3.5C2.67157 2 2 2.67157 2 3.5V12.5C2 13.3284 2.67157 14 3.5 14H7V7V6V2ZM7 1H3.5C2.11929 1 1 2.11929 1 3.5V12.5C1 13.8807 2.11929 15 3.5 15H7H8H12.5C13.8807 15 15 13.8807 15 12.5V7V6V3.5C15 2.11929 13.8807 1 12.5 1H8H7ZM14 6V3.5C14 2.67157 13.3284 2 12.5 2H8V6H14ZM8 7V14H12.5C13.3284 14 14 13.3284 14 12.5V7H8Z"
                              fill="#778192"/>
                    </svg>

                )
            }
            ,
            routeItem: MainContentPage
        },
        {
            name: t(keys.lefPanel.dashboard.main),
            url: '/buy',
            icon: () => {
                return (
                    <svg width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M7 2H3.5C2.67157 2 2 2.67157 2 3.5V12.5C2 13.3284 2.67157 14 3.5 14H7V7V6V2ZM7 1H3.5C2.11929 1 1 2.11929 1 3.5V12.5C1 13.8807 2.11929 15 3.5 15H7H8H12.5C13.8807 15 15 13.8807 15 12.5V7V6V3.5C15 2.11929 13.8807 1 12.5 1H8H7ZM14 6V3.5C14 2.67157 13.3284 2 12.5 2H8V6H14ZM8 7V14H12.5C13.3284 14 14 13.3284 14 12.5V7H8Z"
                              fill="#778192"/>
                    </svg>

                )
            },
            routeItem: BuySubscribePage
        },
        {
            name: t(keys.lefPanel.dashboard.plugins),
            url: '/plugins/:id?',
            icon: () => {
                return (
                    <svg width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M13 6C13 8.14202 11.6896 10.4123 10.2191 12.2503C9.50159 13.1472 8.78159 13.8975 8.24042 14.4236C8.15548 14.5062 8.0751 14.5831 8 14.6541C7.9249 14.5831 7.84452 14.5062 7.75958 14.4236C7.21841 13.8975 6.49841 13.1472 5.78087 12.2503C4.31044 10.4123 3 8.14202 3 6C3 3.23858 5.23858 1 8 1C10.7614 1 13 3.23858 13 6ZM14 6C14 11 8 16 8 16C8 16 2 11 2 6C2 2.68629 4.68629 0 8 0C11.3137 0 14 2.68629 14 6ZM10 6C10 7.10457 9.10457 8 8 8C6.89543 8 6 7.10457 6 6C6 4.89543 6.89543 4 8 4C9.10457 4 10 4.89543 10 6ZM11 6C11 7.65685 9.65685 9 8 9C6.34315 9 5 7.65685 5 6C5 4.34315 6.34315 3 8 3C9.65685 3 11 4.34315 11 6Z"
                              fill="#778192"/>
                    </svg>
                )
            }
            ,
            routeItem: PublicPluginsPage
        },
        {
            name: t(keys.lefPanel.dashboard.account),
            url: '/account',
            icon: () => {
                return (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M11 4C11 5.65685 9.65685 7 8 7C6.34315 7 5 5.65685 5 4C5 2.34315 6.34315 1 8 1C9.65685 1 11 2.34315 11 4ZM12 4C12 6.20914 10.2091 8 8 8C5.79086 8 4 6.20914 4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4ZM1.02242 15C1.27504 12.1968 3.63098 10 6.5 10H9.5C12.369 10 14.725 12.1967 14.9776 15H1.02242ZM9.5 9C12.9216 9 15.7257 11.6438 15.9811 15C15.9936 15.165 16 15.3318 16 15.5V16H15H1H0V15.5C0 15.3318 0.00639146 15.165 0.0189448 15C0.274257 11.6438 3.07839 9 6.5 9H9.5Z"
                              fill="#778192"/>
                    </svg>
                )
            },
            routeItem: AccountPage
        }
    ]
    const setDocHeight = () => {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
    }

    useEffect(() => {
        setDocHeight();
        window.addEventListener('resize', setDocHeight);
        window.addEventListener('orientationchange', setDocHeight);
        return () => {
            window.removeEventListener('resize', setDocHeight);
            window.removeEventListener('orientationchange', setDocHeight);
        }
    }, [])

    return (
        <Router>
            <LanguageProvider>

                <CookieConsent>{t(keys.cookies.text)}<a href={'Docs/data_processing.pdf'}>{t(keys.cookies.text2)}</a></CookieConsent>
                <Switch>
                    <Route exact path={["/", "/about", "/main", "/buy", "/account"]}/>
                    <Route path={["/plugins", "/successPayment"]}/>
                    <Route><div className="page-language-selector"><LangSelector/></div></Route>
                </Switch>
                <Switch>
                    <Route exact path="/invalid-time" component={InvalidLocalTimePage}/>
                    <Route path="/signin-callback.html" component={SignInCallback}/>
                    <Route path="/silent-renew.html" component={SilentRenew}/>
                    <AuthProvider>
                        <ToastProvider>
                            <DataProvider>

                                <Switch>
                                    <PublicRoute exact path="/" Component={WelcomePage}/>

                                    <Route exact path="/about" component={AboutPage}/>

                                    <Route exact path="/contacts" component={Contacts}/>
                                    <PublicRoute exact path="/authorize" Component={LoginPage}/>
                                    <Route path="/reset-password/:code" component={ResetPasswordPage}/>
                                    <Route exact path="/forgot-password" component={ForgotPasswordPage}/>
                                    <Route exact path="/reset-password-error" component={ResetPasswordErrorPage}/>
                                    <Route exact path="/reset-password-confirm"
                                           component={ResetPasswordErrorConfirm}/>
                                    <Route>
                                        <div className="authed-place">
                                            <Navbar/>
                                            <div className="authed-place--content">
                                                <Scrollbars autoHide>
                                                    <Switch>
                                                        {RouteItems.map((routeItem: IRouteItem, index) => {
                                                            return <PrivateRoute key={index} exact
                                                                                 path={routeItem.url}
                                                                                 claimsToHave={routeItem.claimsToHave}
                                                                                 Component={routeItem.routeItem}/>
                                                        })}
                                                        <PrivateRoute path="/successPayment/:id" Component={SuccessPayment}/>
                                                        <Redirect to="/main"/>

                                                    </Switch>
                                                    <Footer/>
                                                </Scrollbars>
                                            </div>
                                        </div>
                                    </Route>
                                </Switch>

                            </DataProvider>
                        </ToastProvider>

                    </AuthProvider>
                </Switch>

            </LanguageProvider>
        </Router>
    );
}

export default App;
